var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrizeB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 173,
    viewBox: "0 0 373 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.653 144.804C296.653 144.804 367.899 176.693 365.115 90.2502C365.115 90.2502 373.481 6.5927 259.176 1.02288C259.176 1.02288 203.422 -1.76203 164.387 54.0051C164.387 54.0051 56.78 204.431 13.0177 77.6354C13.0177 77.6354 31.6667 158.715 84.085 138.421C84.085 138.421 137.95 112.557 170.686 56.7899C170.686 56.7899 192.243 17.3187 236.86 7.77831C236.86 7.77831 359.533 -7.34566 370.683 90.2502C381.848 187.846 296.653 144.804 296.653 144.804Z",
    fill: "#879ECF",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.668 45.6368C147.668 45.6368 96.1867 90.2504 84.2916 56.7902C72.4103 23.3299 147.668 45.6368 147.668 45.6368Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.462 148.816C58.462 148.816 -7.31234 193.499 1.88119 157.212C11.0747 120.925 58.462 148.816 58.462 148.816Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.819 84.6804C158.819 84.6804 173.402 129.418 153.567 132.148C133.733 134.878 158.819 84.6804 158.819 84.6804Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeB);
export default __webpack_public_path__ + "static/media/prize_b.a705978550f1c94cef7583cff1f4e65c.svg";
export { ForwardRef as ReactComponent };